import { render, staticRenderFns } from "./NewFormBuilder.vue?vue&type=template&id=47dfa1f8&scoped=true"
import script from "./NewFormBuilder.vue?vue&type=script&lang=js"
export * from "./NewFormBuilder.vue?vue&type=script&lang=js"
import style0 from "./NewFormBuilder.vue?vue&type=style&index=0&id=47dfa1f8&prod&lang=scss&scoped=true"
import style1 from "./NewFormBuilder.vue?vue&type=style&index=1&id=47dfa1f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dfa1f8",
  null
  
)

export default component.exports